module.exports = __webpack_public_path__ + "static/media/5.494122c6.png";